const formInputValidationMessages = function (input) {
	//CHECKS WHAT TYPE OF FIELD AND PASSES BACK THE ERROR MESSAGE & FIELD ID

	if (input.name === 'subject_select') {
		if (input.value === '' || input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}
	}

	if (input.name === 'issues_select') {
		if (input.value === '' || input.value.trim() === '' || input.value === 'Select an issue') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}
	}

	if (input.name === 'email address') {
		//SANITY CHECK EMAIL FORMAT
		const re = /.+\@.+\..+/;
		if (!input.value || !re.test(input.value) || input.value.trim() === '') {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.name === 'first name') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}
		if (input.value.length > 20 || input.value.length < 2) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.name === 'last name') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}
		if (input.value.length > 30 || input.value.length < 2) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.id.substring(0, 3) === 'dob') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}

		if (Number.isNaN(Number(input.value))) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}

		if (input.name === 'day') {
			const month = document.querySelector('#dob_month').value;
			const year = document.querySelector('#dob_year').value;
			const lastDayOfMonth = new Date(year, month, 0).getDate();

			if (month && year) {
				const inputAsNum = parseInt(input.value, 10);
				if (inputAsNum > lastDayOfMonth || inputAsNum === 0) {
					//IF DAY ENTERED NOT IN MONTH
					return { message: input.dataset.inputInvalidDay, input, fieldErrorId: input.id };
				}
			}
		}

		if (input.name === 'month') {
			if (input.value > 12 || input.value === 0) {
				return { message: input.dataset.inputInvalidMonth, input, fieldErrorId: input.id };
			}
		}

		if (input.name === 'year') {
			const day = document.querySelector('#dob_day');
			const month = document.querySelector('#dob_month');
			const currentDay = new Date();
			const currentYear = currentDay.getFullYear();
			const enteredDay = new Date(`${month.value}/${day.value}/${input.value}`);

			if (Date.parse(currentDay) < Date.parse(enteredDay)) {
				return {
					message: input.dataset.inputInvalidYear_past,
					input: [day.id, month.id, input.id],
					fieldErrorId: 'dob',
				};
			}

			if (input.value.length < 4 || input.value.length > 4) {
				return { message: input.dataset.inputInvalidYear_format, input, fieldErrorId: 'dob' };
			}

			if (currentYear - 130 > input.value) {
				return { message: input.dataset.inputInvalidYear_age, input, fieldErrorId: 'dob' };
			}
		}
	}

	if (input.name === 'postcode') {
		const inputWithoutSpaces = input.value.replace(/\s/g, '');
		//POSTCODE REGEX FROM UK GOV
		const re =
			/([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([AZa-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))[0-9][A-Za-z]{2})/;
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}
		if (!re.test(inputWithoutSpaces)) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.id === 'phone_consent-yes') {
		var noInput = document.querySelector('#phone_consent-no');
		if (!input.checked && !noInput.checked) {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: 'phone_consent' };
		}
	}

	if (input.id === 'phone_consent-no') {
		var yesInput = document.querySelector('#phone_consent-yes');
		if (!input.checked && !yesInput.checked) {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: 'phone_consent' };
		}
	}

	if (input.name === 'phone number') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}

		if (input.value.trim().length < 10 || input.value.trim().length > 14) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.id === 'insurance_bought-yes') {
		var noInput = document.querySelector('#insurance_bought-no');
		if (!input.checked && !noInput.checked) {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: 'insurance_bought' };
		}
	}

	if (input.id === 'insurance_bought-no') {
		var yesInput = document.querySelector('#insurance_bought-yes');
		if (!input.checked && !yesInput.checked) {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: 'insurance_bought' };
		}
	}

	if (input.id === 'message_subject') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}

		if (input.value.length > 255) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}

	if (input.id === 'message_content') {
		if (input.value.trim() === '') {
			return { message: input.dataset.inputSkipped, input, fieldErrorId: input.id };
		}

		if (input.value.length > 32000) {
			return { message: input.dataset.inputInvalid, input, fieldErrorId: input.id };
		}
	}
};

const KeyPressValidator = function (e, input) {
	const code = e.keyCode || e.which;

	if (input.id.substring(0, 3) === 'dob') {
		if (code === 8 || code === 13 || code === 9 || code === 27 || code === 110) {
			return;
		}

		if (isNaN(parseInt(String.fromCharCode(code), 10))) {
			e.preventDefault();
			return false;
		}
	}

	if (input.id === 'phone_number') {
		if (
			code === 8 ||
			code === 13 ||
			code === 9 ||
			code === 27 ||
			code === 32 ||
			code === 188 ||
			code === 43 ||
			code === 187
		) {
			return;
		}

		if (isNaN(parseInt(String.fromCharCode(code), 10))) {
			e.preventDefault();
			return false;
		}
	}
};

const formValidator = {
	form: document.getElementById('cnfsd-contact-form'),
	totalErrors: 0,
	formInputs: [],
	validateKeys: KeyPressValidator,
	validateInput: formInputValidationMessages,

	init: () => {
		formValidator.formInputs = formValidator.form.querySelectorAll('.field-group');
		formValidator.validateOnInputEntry();
		formValidator.handleSubmitEvent();
	},

	validateOnFormSubmit: formInputs => {
		// RESET FORM ERRORS TO ZERO
		const fieldErrors = [];
		formInputs.forEach(field => {
			const inputErrors = formValidator.validateInputs(field);
			if (inputErrors) fieldErrors.push(inputErrors);
		});

		return fieldErrors;
	},

	handleSubmitEvent: function () {
		formValidator.form.addEventListener('submit', function (e) {
			e.preventDefault();
			const formInputs = formValidator.form.querySelectorAll('.field-group:not(.display-none)');
			const fieldErrors = formValidator.validateOnFormSubmit(formInputs);

			//IF VALID FORM HAS ITEMS, THERE ARE ERRORS SO DONT SUBMIT FORM
			if (fieldErrors.length > 0) {
				const error = document.querySelector('.field-group--error');
				const rect = error.getBoundingClientRect().top + window.pageYOffset + -140;
				window.scrollTo({ behavior: 'smooth', top: rect });

				return;
			}

			//NO ERRORS IN FORM
			contactFormFlow.updateDataLayer();
			contactFormFlow.submitForm();
		});
	},

	validateOnInputEntry: function () {
		formValidator.formInputs.forEach(field => {
			//GET ALL INPUTS IN FORM (SPLIT INTO TEXT INPUTS & CLICKABLE INPUTS)
			const textInputs = field.querySelectorAll(
				"input[type='text'], input[type='email'], input[type='password'], input[type='number'], textarea"
			);
			const clickableInputs = field.querySelectorAll("input[type='radio'], input[type='checkbox'], select");

			textInputs.forEach(input => {
				input.addEventListener('input', event => {
					// REMOVE ERROR ON INPUT CHANGE
					formValidator.removeErrorOnFormInput(input, field);
					// VALIDATE KEYS ON INPUT
					formValidator.validateKeys(event, input);
				});
			});

			clickableInputs.forEach(input => {
				input.addEventListener('click', e => {
					formValidator.removeErrorOnFormInput(input, field);
				});
			});
		});
	},

	validateInputs: function (field) {
		//GET INPUTS FROM FIELD
		const inputs = Array.from(field.querySelectorAll('input, textarea, select'));

		//ARRAY AS EACH FIELD COULD HAVE MULTIPLE INPUTS (DATE)
		const inputErrors = [];
		inputs.forEach(input => {
			const errorMessageObject = formValidator.validateInput(input, field);

			if (errorMessageObject) {
				errorMessageObject.field = field; // ADDING FIELD
				inputErrors.push(errorMessageObject); //PUSH ERROR INTO ARRAY OF ERRORS

				//IF UNIQUE fieldErrorId ADD IT TO THE COLLECTION OF FIELD ERROR IDS FOR DATA LAYER
				if (!contactFormFlow.fieldErrors.includes(errorMessageObject.fieldErrorId)) {
					contactFormFlow.fieldErrors.push(errorMessageObject.fieldErrorId);
				}
			}
		});

		if (inputErrors.length > 0) {
			formValidator.showValidationMessages(inputErrors);
		}

		return inputErrors.length > 0 ? inputErrors : undefined;
	},

	showValidationMessages: function (errorMessages) {
		const { message, field } = errorMessages[0];

		//IF ERROR MESSAGE NODE EXISTS, DO NOT CREATE ANOTHER ONE
		if (!field.querySelector('.error-message')) formValidator.createErrorMessageNode(field, message);

		//SET EVERY ERRORING INPUT TO HAVE BORDER COLOUR
		errorMessages.forEach(({ input }) => {
			formValidator.setErrorBorderColour(input);
		});

		field.classList.add('field-group--error');
	},

	setErrorBorderColour: input => {
		input.setAttribute('aria-invalid', true);
	},

	createErrorMessageNode: (field, message) => {
		//CREATE DIVS
		const fieldValidationError = document.createElement('div');
		const errorMessage = document.createElement('div');
		const label = field.querySelector('label.label--standard, legend');

		//ADD CLASSES TO DIVS
		fieldValidationError.classList.add('field-validation-error');
		errorMessage.classList.add('error-message');

		//ADD ERROR MESSAGE
		errorMessage.innerText = message;

		//ADD MESSAGE TO PARENT CONTAINER
		fieldValidationError.appendChild(errorMessage);

		//ADD VALIDATION ERROR NODE TO FIELD
		if (label) {
			field.insertBefore(fieldValidationError, label.nextSibling);
		} else {
			field.prepend(fieldValidationError);
		}
	},

	removeErrorOnFormInput: function (input, field) {
		//REMOVE RED BORDER FROM INPUT
		input?.removeAttribute('aria-invalid');

		//REMOVE ERROR MESSAGE FROM FIELD
		field.classList.remove('field-group--error');
	},
};

var contactFormFlow = {
	form: document.getElementById('cnfsd-contact-form'),

	errorSummaryBox: document.querySelector('.mod-error-summary'),

	hasQueryString: window.location.href.indexOf('?product'),

	loginLinkNode: document.getElementById('Login_Link'),

	selectedAssistance: null,

	jsonData: null,

	fieldErrors: [],

	init: function () {
		//GET JSON DATA FROM SCRIPT TAG
		this.getJsonData();

		if (!this.jsonData) return;

		//INITIALISE FORM VALIDATOR
		formValidator.init();

		//INITIALISE FORM EVENT LISTENERS
		this.assistanceForm.init();
		this.contactDetailsForm.init();

		if (this.hasQueryString) {
			this.handleQueryStringOnLoad();
			this.parseQueryString(this.hasQueryString);
		}

		this.initLoginLink();
	},

	getJsonData: function () {
		const data = document.getElementById('cnfsd-contact-jsonData').textContent;
		this.jsonData = JSON.parse(data);
	},

	handleQueryStringOnLoad: function () {
		// IF QUERY STRING EXISTS, RESET THE UI
		this.assistanceForm.resetRadioValues();
		this.contactDetailsForm.resetRadioValues();
		this.assistanceForm.toggleThumbsUpCard(false);
		this.contactDetailsForm.toggleContactDetailsForm(false);
	},

	parseQueryString: function (substringIndex) {
		const queryString = window.location.href.substring(substringIndex + 1);
		const selectQueryStrings = queryString.split('&');

		selectQueryStrings.forEach(item => {
			const selectValue = item.substring(item.indexOf('=') + 1);
			const parsedValue = selectValue.split('%27').join("'").split('%20').join(' ');

			// IF QUERY STRING MATCH INCLUDES PRODUCT, SET THE SELECT VALUE TO THAT PRODUCT TYPE
			if (item.includes('product')) {
				this.setSelectAsQuerystringValue(
					this.assistanceForm.categorySelect,
					parsedValue,
					this.assistanceForm.handleOnCategoryChange
				);
			}

			if (item.includes('moreInformation')) {
				this.setSelectAsQuerystringValue(
					this.assistanceForm.issueSelect,
					parsedValue,
					this.assistanceForm.dispatchIssuesSelectChange
				);
			}
		});
	},

	updateDataLayer: function () {
		dataLayer.push({
			event: 'Contact Us',
			eventSuccess: true,
			eventErrors: this.fieldErrors,
		});
	},

	setSelectAsQuerystringValue: function (input, value, callback) {
		//SETS VALUE OF SELECT TO QUERY STRING
		const options = input.querySelectorAll('option');

		const matchingOption = Array.from(options).find(
			(option, i) => option.value.toLowerCase() === value.toLowerCase()
		);

		// IF MATCHING OPTION FOUND, SET SELECTED INDEX AND CALL FUNCTION TO UPDATE UI
		if (matchingOption) {
			input.selectedIndex = Array.from(options).indexOf(matchingOption);
			callback(input);
		}
	},

	initLoginLink: function () {
		this.loginLinkNode.addEventListener('click', e => {
			e.stopPropagation();
			e.preventDefault();
			this.handleLoginLinkCreation();
		});
	},

	handleLoginLinkCreation: function () {
		const baseLink = this.loginLinkNode.href;

		let queryParams = `?product=${encodeURIComponent(contactFormFlow.categorySelect.value)}`;

		if (contactFormFlow.issueSelect.value)
			queryParams += `&moreInformation=${encodeURIComponent(contactFormFlow.issueSelect.value)}`;

		const loginLink = `${baseLink}${queryParams}`;
		// REDIRECT TO LOGIN LINK WITH QUERY PARAMETERS
		window.location.href = loginLink;
	},

	createOptionNodeHelper: (optionText, optionValue, select) => {
		const option = document.createElement('option');
		option.innerHTML = optionText;
		option.value = optionValue;
		select.appendChild(option);

		return select;
	},

	assistanceForm: {
		categorySelect: document.getElementById('subject_select'),
		issueSelect: document.getElementById('issues_select'),

		showContactDetailsForm: document.getElementById('q0-yes'),
		showThumbsUpResponse: document.getElementById('q0-no'),

		continueButton: document.getElementById('cfq0-continue'),

		infoBoxSection: {
			container: document.getElementById('cfq-question-toggle'),
			infoBoxTitle: document.querySelector('.mod-info-box span'),
			infoBoxContent: document.querySelector('.mod-info-box p'),
		},

		formSuccessCard: document.getElementById('cfq-contact-success'),

		init: function () {
			// SET UP EVENT SELECT OPTIONS
			this.initialiseCategorySelect();
			this.initialiseIssuesSelect();

			this.continueButton.onclick = e => {
				e.preventDefault();
				this.handleContinueButtonClick();
			};

			this.showThumbsUpResponse.onchange = e => {
				this.toggleThumbsUpCard(true);
				contactFormFlow.contactDetailsForm.toggleContactDetailsForm(false);
			};

			this.showContactDetailsForm.onchange = e => {
				this.toggleThumbsUpCard(false);
				contactFormFlow.contactDetailsForm.toggleContactDetailsForm(true);
			};
		},

		resetRadioValues: function () {
			//RESET THE RADIOS TO FALSE
			this.showContactDetailsForm.checked = false;
			this.showThumbsUpResponse.checked = false;
		},

		initialiseCategorySelect: function () {
			if (!this.categorySelect) return;

			//LOOP THROUGH JSON DATA AND CREATE OPTIONS FOR SUBJECT SELECT
			contactFormFlow.jsonData.forEach(item => {
				contactFormFlow.createOptionNodeHelper(item.subject, item.subjectValue, this.categorySelect);
			});

			this.categorySelect.onchange = e => {
				//RESET UI ON SUBJECT CHANGE
				contactFormFlow.contactDetailsForm.toggleContactDetailsForm(false);
				this.resetRadioValues();
				//POPULATE ISSUES SELECT OPTIONS BASED ON SUBJECT SELECTED
				this.handleOnCategoryChange();
			};
		},

		initialiseIssuesSelect: function () {
			if (!this.issueSelect) return;

			this.issueSelect.onchange = e => {
				this.handleInfoBoxContent(e.target);
			};
		},

		handleOnCategoryChange: function () {
			const categorySelect = this.categorySelect;

			const selectedData = contactFormFlow.jsonData.find(data => data.subjectValue === categorySelect.value);

			if (!selectedData) return;

			// SET THE ASSISTANCE USER SELECTED
			contactFormFlow.selectedAssistance = selectedData;

			// CHECK IF INSURANCE PRODUCT
			contactFormFlow.contactDetailsForm.handleIsInsuranceProduct(selectedData.isInsuranceProduct);

			// POPULATE ISSUES SELECT OPTIONS
			this.handleCreateIssueSelectOptions(selectedData.issues);

			this.toggleInfoBoxVisibility(false); // HIDE INFO BOX ON CATEGORY CHANGE
		},

		dispatchIssuesSelectChange: function () {
			// TRIGGER CHANGE EVENT MANUALLY TO UPDATE INFO BOX
			this.issueSelect.dispatchEvent(new Event('change'));
		},

		handleCreateIssueSelectOptions: function (issues) {
			const issueSelect = this.issueSelect;

			//REMOVE ALL OPTIONS EXCEPT THE FIRST ONE
			Array.from(issueSelect.options).forEach((option, index) => {
				if (index !== 0) {
					issueSelect.removeChild(option);
				}
			});

			//CREATE OPTIONS FOR EACH ISSUE IN THE ISSUE SELECT
			issues.forEach(issue => {
				contactFormFlow.createOptionNodeHelper(issue.question, issue.questionValue, issueSelect);
			});

			//IF THERE IS ONLY ONE ISSUE, SET IT AS SELECTED & HIDE THE SELECT
			if (issues.length === 1) {
				this.toggleFieldVisibility(issueSelect.closest('.field-group'), false);
				issueSelect.value = issues[0].questionValue;
				this.dispatchIssuesSelectChange(); // TRIGGER CHANGE EVENT TO UPDATE INFO BOX
			} else {
				//IF THERE ARE MULTIPLE ISSUES, MAKE THE SELECT VISIBLE
				this.toggleFieldVisibility(issueSelect.closest('.field-group'), true);
				issueSelect.value = '';
			}
		},

		toggleFieldVisibility: function (field, isVisible) {
			if (!field) return;

			if (isVisible) {
				field.classList.remove('display-none');
			} else {
				field.classList.add('display-none');
			}
		},

		handleInfoBoxContent: function (option) {
			const selectedIssue = contactFormFlow.selectedAssistance.issues.find(
				issue => issue.questionValue === option.value
			);

			if (!selectedIssue) return;

			this.infoBoxSection.infoBoxTitle.innerHTML = selectedIssue.question;
			this.infoBoxSection.infoBoxContent.innerHTML = selectedIssue.answer;
		},

		handleContinueButtonClick: function () {
			let isValid = true;

			if (!this.categorySelect.value) {
				const field = this.categorySelect.closest('.field-group');
				formValidator.validateInputs(field);
				isValid = false;
			}

			if (!this.issueSelect.value) {
				const field = this.issueSelect.closest('.field-group');
				formValidator.validateInputs(field);
				isValid = false;
			}

			//IF EITHER ISSUES SELECT OR SUBJECT SELECT ARE NOT VALID, DO NOT SHOW NEXT SECTION
			if (isValid) this.toggleInfoBoxVisibility(true);
		},

		toggleInfoBoxVisibility: function (isVisible) {
			this.infoBoxSection.container.classList.toggle('display-none', !isVisible);
			this.continueButton.classList.toggle('display-none', isVisible);
		},

		toggleThumbsUpCard: function (isVisible) {
			this.formSuccessCard.classList.toggle('display-none', !isVisible);
		},
	},

	contactDetailsForm: {
		form: document.getElementById('cfq-contact-details-form'),

		insuranceFieldGroup: {
			field: document.getElementById('insurance_bought-group'),
			yes: document.getElementById('insurance_bought-yes'),
			no: document.getElementById('insurance_bought-no'),
		},

		phoneConsentGroup: {
			field: document.getElementById('phone_consent-group'),
			yes: document.getElementById('phone_consent-yes'),
			no: document.getElementById('phone_consent-no'),
			numberInput: document.getElementById('phone_number'),
			numberField: null,
		},

		init: function () {
			this.phoneConsentGroup.numberField = this.phoneConsentGroup?.numberInput.closest('.field-group');

			this.phoneConsentGroup.numberField.classList.add('display-none');

			this.phoneConsentGroup.yes.onchange = e => {
				this.togglePhoneNumberField(true);
			};

			this.phoneConsentGroup.no.onchange = e => {
				this.togglePhoneNumberField(false);
			};
		},

		resetRadioValues: function () {
			//RESET RADIOS
			this.insuranceFieldGroup.yes.checked = false;
			this.insuranceFieldGroup.no.checked = false;

			this.phoneConsentGroup.yes.checked = false;
			this.phoneConsentGroup.no.checked = false;
		},

		toggleContactDetailsForm: function (isVisible) {
			if (isVisible) {
				this.form.classList.remove('display-none');
			} else {
				this.form.classList.add('display-none');
				this.resetRadioValues();
			}
		},

		handleIsInsuranceProduct: function (isAnInsuranceProduct) {
			this.insuranceFieldGroup.field.classList.toggle('display-none', !isAnInsuranceProduct);
		},

		togglePhoneNumberField: function (isVisible) {
			this.phoneConsentGroup.numberField.classList.toggle('display-none', !isVisible);
		},
	},

	submitForm: function () {
		//IF FORM IS VALID, SUBMIT THE INPUTS VALUES
		const dobDay = document.getElementById('dob_day').value;
		const dobMon = document.getElementById('dob_month').value;
		const dobYear = document.getElementById('dob_year').value;

		const formInformation = {
			product: document.getElementById('subject_select').value,
			MoreInformation: document.getElementById('issues_select').value,
			Title: null,
			FirstName: document.getElementById('first_name').value,
			Surname: document.getElementById('last_name').value,
			EmailAddress: document.getElementById('email_address').value,
			Postcode: document.getElementById('postcode').value,
			DateOfBirth: `${dobDay}/${dobMon}/${dobYear}`,
			ContactPhoneQuestion: document.querySelector("input[name='phone_consent']:checked").value,
			ContactPhoneNumber: document.getElementById('phone_number').value,
			HasPurchased: document.querySelector("input[name='insurance_bought']:checked")
				? document.querySelector("input[name='insurance_bought']:checked").value
				: '1',
			QuerySubject: document.getElementById('message_subject').value,
			QueryDescription: document.getElementById('message_content').value,
			HttpAttributeReturnUrl: document.getElementById('returnUrl')
				? document.getElementById('returnUrl').value
				: '',
			HttpAttributePriority: document.getElementById('HttpAttributePriority')
				? document.getElementById('HttpAttributePriority').value
				: '',
			HttpAttributeOrigin: document.getElementById('HttpAttributeOrigin')
				? document.getElementById('HttpAttributeOrigin').value
				: '',
			HttpAttributeExternal: document.getElementById('HttpAttributeExternal')
				? document.getElementById('HttpAttributeExternal').value
				: '',
		};

		const xhr = new XMLHttpRequest();
		xhr.open('POST', '/api/contact-us/self-serve-submit');

		xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');

		xhr.onload = function () {
			if (xhr.readyState === xhr.DONE) {
				if (xhr.status === 200) {
					const response = JSON.parse(xhr.response);
					if (response.Success) {
						const returnUrl = document.getElementById('returnUrl').value;
						window.location.href = returnUrl;
					} else {
						contactFormFlow.errorSummaryBox.style.display = '';
						var rect =
							contactFormFlow.errorSummaryBox.getBoundingClientRect().top + window.pageYOffset + -140;
						window.scrollTo({ behavior: 'smooth', top: rect });
					}
				} else {
					contactFormFlow.errorSummaryBox.style.display = '';
					var rect = contactFormFlow.errorSummaryBox.getBoundingClientRect().top + window.pageYOffset + -140;
					window.scrollTo({ behavior: 'smooth', top: rect });
				}
			}
		};
		xhr.send(JSON.stringify(formInformation));
	},
};

document.addEventListener('DOMContentLoaded', function () {
	if (formValidator.form) {
		contactFormFlow.init();
	}
});
